/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentDrug from './treatment-drug';
import TreatmentDrugDetail from './treatment-drug-detail';
import TreatmentDrugUpdate from './treatment-drug-update';
import TreatmentDrugDeleteDialog from './treatment-drug-delete-dialog';

const TreatmentDrugRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentDrug />} />
    <Route path="new" element={<TreatmentDrugUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentDrugDetail />} />
      <Route path="edit" element={<TreatmentDrugUpdate />} />
      <Route path="delete" element={<TreatmentDrugDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentDrugRoutes;
